var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import { APP_OPTION_LIST, BLOCK_CREATE, BLOCK_DELETE, BLOCK_DUPLICATE, BLOCK_UPDATE, CONNECTOR_CREATE, CONNECTOR_DELETE, CONNECTOR_UPDATE, CUSTOM_LOGIC_CREATE, CUSTOM_LOGIC_DELETE, CUSTOM_LOGIC_READ, CUSTOM_LOGIC_READ_ALL, CUSTOM_LOGIC_UPDATE, DUPLICATE_CUSTOM_LOGIC, RESET_SELECTED_CUSTOM_LOGIC, SET_CANVAS_OFFSET, SET_CANVAS_SELECTION, SET_CHANGES_SAVING_STATE, SET_CUSTOM_LOGIC_SUBSCRIPTION, SET_DELETE_CONFIRMATION_MODAL_VISIBILITY, SET_DUPLICATE_CONFIG_MODAL_VISIBILITY, SET_DYNAMIC_MODAL_VISIBILITY, SET_OUTPUT_PARAM_SYNC, SET_PROPERTIES_BAR_VISIBILITY, SET_SELECTED_CUSTOM_LOGIC, SET_SELECTED_ENTITY, } from './constants';
import { RESPONSE_STATUS, } from './models';
export var getInitialState = function () { return ({
    isSavingChanges: false,
    appOptionList: { data: [], status: RESPONSE_STATUS.IDLE },
    selectedCustomLogicId: '',
    propertiesBarState: null,
    deleteConfirmationModalState: null,
    isDuplicateConfigModalVisible: false,
    dynamicModalState: null,
    isCanvasSelected: false,
    selectedEntity: null,
    canvasOffset: { x: 0, y: 0 },
    outputParamSync: null,
    customLogicSubscription: null,
    customLogicToDelete: { id: '', name: '' },
    customLogicDuplicateState: RESPONSE_STATUS.IDLE,
    customLogic: {
        create: { data: undefined, status: RESPONSE_STATUS.IDLE },
        read: { data: undefined, status: RESPONSE_STATUS.IDLE },
        readAll: { data: [], status: RESPONSE_STATUS.IDLE },
        update: { data: undefined, status: RESPONSE_STATUS.IDLE },
        delete: { data: undefined, status: RESPONSE_STATUS.IDLE },
    },
    block: {
        create: { data: undefined, status: RESPONSE_STATUS.IDLE },
        update: { data: undefined, status: RESPONSE_STATUS.IDLE, ref: '' },
        delete: { data: undefined, status: RESPONSE_STATUS.IDLE, ref: '' },
    },
    connector: {
        create: { data: undefined, status: RESPONSE_STATUS.IDLE },
        update: { data: undefined, status: RESPONSE_STATUS.IDLE, ref: '' },
        delete: { data: undefined, status: RESPONSE_STATUS.IDLE },
    },
}); };
var LogicBuilderReducer = function (currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
        switch (action.type) {
            case SET_SELECTED_CUSTOM_LOGIC:
                state.selectedCustomLogicId = action.logicPatchworkId;
                break;
            case RESET_SELECTED_CUSTOM_LOGIC:
                state.selectedCustomLogicId = '';
                break;
            case SET_PROPERTIES_BAR_VISIBILITY:
                state.propertiesBarState = action.visibility;
                break;
            case SET_DELETE_CONFIRMATION_MODAL_VISIBILITY:
                state.deleteConfirmationModalState = action.visibility;
                break;
            case SET_DUPLICATE_CONFIG_MODAL_VISIBILITY:
                state.isDuplicateConfigModalVisible = action.visibility;
                break;
            case SET_DYNAMIC_MODAL_VISIBILITY:
                state.dynamicModalState = action.visibility;
                break;
            case SET_CANVAS_SELECTION:
                state.isCanvasSelected = action.selected;
                break;
            case SET_SELECTED_ENTITY:
                state.selectedEntity = action.entity;
                break;
            case SET_CANVAS_OFFSET:
                state.canvasOffset = action.offset;
                break;
            case SET_OUTPUT_PARAM_SYNC:
                state.outputParamSync = action.data;
                break;
            case SET_CHANGES_SAVING_STATE:
                if (state.isSavingChanges !== action.state) {
                    state.isSavingChanges = (_a = action.state) !== null && _a !== void 0 ? _a : false;
                }
                break;
            case SET_CUSTOM_LOGIC_SUBSCRIPTION:
                state.customLogicSubscription = action.payload;
                break;
            case CUSTOM_LOGIC_CREATE.REQUEST:
                state.customLogic.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case CUSTOM_LOGIC_CREATE.SUCCESS:
                state.customLogic.create = {
                    data: action === null || action === void 0 ? void 0 : action.data,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case CUSTOM_LOGIC_CREATE.ERROR:
                state.customLogic.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case CUSTOM_LOGIC_CREATE.RESET:
                state.customLogic.create = getInitialState().customLogic.create;
                break;
            case CUSTOM_LOGIC_READ.REQUEST:
                if ((action === null || action === void 0 ? void 0 : action.silentUpdate) && !!((_b = state.customLogic) === null || _b === void 0 ? void 0 : _b.read)) {
                    state.customLogic.read.status = action.isRefresh
                        ? RESPONSE_STATUS.IDLE
                        : RESPONSE_STATUS.LOADING;
                }
                else {
                    state.customLogic.read = {
                        data: undefined,
                        status: action.isRefresh
                            ? RESPONSE_STATUS.IDLE
                            : RESPONSE_STATUS.LOADING,
                    };
                }
                break;
            case CUSTOM_LOGIC_READ.SUCCESS:
                state.customLogic.read = {
                    data: action === null || action === void 0 ? void 0 : action.data,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case CUSTOM_LOGIC_READ.ERROR:
                state.customLogic.read = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case CUSTOM_LOGIC_READ_ALL.REQUEST:
                state.customLogic.readAll = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case CUSTOM_LOGIC_READ_ALL.SUCCESS:
                state.customLogic.readAll = {
                    data: action === null || action === void 0 ? void 0 : action.data,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case CUSTOM_LOGIC_READ_ALL.ERROR:
                state.customLogic.readAll = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case CUSTOM_LOGIC_UPDATE.REQUEST:
                if ((action === null || action === void 0 ? void 0 : action.ref) &&
                    (action === null || action === void 0 ? void 0 : action.data) &&
                    !!((_d = (_c = state.customLogic) === null || _c === void 0 ? void 0 : _c.read) === null || _d === void 0 ? void 0 : _d.data) &&
                    state.customLogic.read.data.id === action.ref) {
                    state.customLogic.read.data = action.data;
                }
                if ((_e = state.customLogic) === null || _e === void 0 ? void 0 : _e.update) {
                    state.customLogic.update.status = RESPONSE_STATUS.LOADING;
                }
                break;
            case CUSTOM_LOGIC_UPDATE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.ref) && (action === null || action === void 0 ? void 0 : action.data) && !!((_g = (_f = state.customLogic) === null || _f === void 0 ? void 0 : _f.readAll) === null || _g === void 0 ? void 0 : _g.data)) {
                    var logicIndex = (_h = state.customLogic.readAll.data) === null || _h === void 0 ? void 0 : _h.findIndex(function (logic) { return logic.id === action.ref; });
                    if (logicIndex !== -1) {
                        state.customLogic.readAll.data[logicIndex] = action.data;
                    }
                }
                if ((action === null || action === void 0 ? void 0 : action.ref) &&
                    (action === null || action === void 0 ? void 0 : action.data) &&
                    !!((_k = (_j = state.customLogic) === null || _j === void 0 ? void 0 : _j.read) === null || _k === void 0 ? void 0 : _k.data) &&
                    ((_l = state.customLogic.read.data) === null || _l === void 0 ? void 0 : _l.id) === (action === null || action === void 0 ? void 0 : action.ref)) {
                    state.customLogic.read.data = __assign({}, action.data);
                }
                if ((_m = state.customLogic) === null || _m === void 0 ? void 0 : _m.update) {
                    state.customLogic.update.status = RESPONSE_STATUS.SUCCESS;
                }
                break;
            case CUSTOM_LOGIC_UPDATE.ERROR:
                if ((_o = state.customLogic) === null || _o === void 0 ? void 0 : _o.update) {
                    state.customLogic.update.status = RESPONSE_STATUS.ERROR;
                    state.customLogic.update.ref = action === null || action === void 0 ? void 0 : action.ref;
                }
                break;
            case CUSTOM_LOGIC_UPDATE.RESET:
                if ((_p = state.customLogic) === null || _p === void 0 ? void 0 : _p.update) {
                    state.customLogic.update = getInitialState().customLogic.update;
                }
                break;
            case CUSTOM_LOGIC_DELETE.SET:
                state.customLogicToDelete = {
                    id: (_r = (_q = action.ref) === null || _q === void 0 ? void 0 : _q.id) !== null && _r !== void 0 ? _r : '',
                    name: (_t = (_s = action.ref) === null || _s === void 0 ? void 0 : _s.name) !== null && _t !== void 0 ? _t : '',
                };
                break;
            case CUSTOM_LOGIC_DELETE.REQUEST:
                if (((_u = action === null || action === void 0 ? void 0 : action.ref) === null || _u === void 0 ? void 0 : _u.id) && !!((_w = (_v = state.customLogic) === null || _v === void 0 ? void 0 : _v.readAll) === null || _w === void 0 ? void 0 : _w.data)) {
                    var tempIndex = (_x = state.customLogic.readAll.data) === null || _x === void 0 ? void 0 : _x.findIndex(function (logic) { var _a; return logic.id === ((_a = action.ref) === null || _a === void 0 ? void 0 : _a.id); });
                    state.customLogic.readAll.data =
                        (_y = state.customLogic.readAll.data) === null || _y === void 0 ? void 0 : _y.filter(function (customLogic) { var _a; return customLogic.id !== ((_a = action.ref) === null || _a === void 0 ? void 0 : _a.id); });
                    var modifiedCustomLogicArray = state.customLogic.readAll.data;
                    var nextItem = (_0 = (_z = modifiedCustomLogicArray.at(tempIndex)) !== null && _z !== void 0 ? _z : modifiedCustomLogicArray.at(tempIndex - 1)) !== null && _0 !== void 0 ? _0 : modifiedCustomLogicArray.at(tempIndex + 1);
                    if (nextItem) {
                        state.selectedCustomLogicId = nextItem.id;
                    }
                    else {
                        state.selectedCustomLogicId = '';
                    }
                }
                state.customLogic.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case CUSTOM_LOGIC_DELETE.SUCCESS:
                state.propertiesBarState = null;
                state.customLogic.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                    ref: (_2 = (_1 = action.ref) === null || _1 === void 0 ? void 0 : _1.id) !== null && _2 !== void 0 ? _2 : '',
                };
                break;
            case CUSTOM_LOGIC_DELETE.ERROR:
                state.customLogic.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                    ref: (_4 = (_3 = action.ref) === null || _3 === void 0 ? void 0 : _3.id) !== null && _4 !== void 0 ? _4 : '',
                };
                break;
            case CUSTOM_LOGIC_DELETE.RESET:
                state.customLogic.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                    ref: '',
                };
                break;
            case BLOCK_CREATE.REQUEST:
                state.block.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case BLOCK_CREATE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.data) &&
                    ((_5 = state.customLogic.read) === null || _5 === void 0 ? void 0 : _5.data) &&
                    ((_6 = state.customLogic.read.data) === null || _6 === void 0 ? void 0 : _6.id) === action.data.patchwork) {
                    state.customLogic.read.data.patches = __spreadArray(__spreadArray([], state.customLogic.read.data.patches, true), [
                        action.data,
                    ], false);
                }
                state.block.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case BLOCK_CREATE.ERROR:
                state.block.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case BLOCK_CREATE.RESET:
                state.block.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                    ref: '',
                };
                break;
            case BLOCK_UPDATE.REQUEST:
                if ((action === null || action === void 0 ? void 0 : action.data) && ((_8 = (_7 = state.customLogic) === null || _7 === void 0 ? void 0 : _7.read) === null || _8 === void 0 ? void 0 : _8.data)) {
                    var staleBlockIndex = (_10 = (_9 = state.customLogic.read.data) === null || _9 === void 0 ? void 0 : _9.patches) === null || _10 === void 0 ? void 0 : _10.findIndex(function (block) { var _a; return block.id === ((_a = action.data) === null || _a === void 0 ? void 0 : _a.id); });
                    if (staleBlockIndex > -1) {
                        state.customLogic.read.data.patches[staleBlockIndex] =
                            action.data;
                    }
                }
                state.block.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_UPDATE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.data) && ((_11 = state.customLogic) === null || _11 === void 0 ? void 0 : _11.read)) {
                    state.customLogic.read.data = action.data;
                }
                state.block.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_UPDATE.ERROR:
                state.block.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_UPDATE.RESET:
                state.block.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                    ref: '',
                };
                break;
            case BLOCK_DELETE.REQUEST:
                if ((action === null || action === void 0 ? void 0 : action.ref) && !!((_14 = (_13 = (_12 = state.customLogic) === null || _12 === void 0 ? void 0 : _12.read) === null || _13 === void 0 ? void 0 : _13.data) === null || _14 === void 0 ? void 0 : _14.patches)) {
                    state.customLogic.read.data.patches =
                        (_15 = state.customLogic.read.data.patches) === null || _15 === void 0 ? void 0 : _15.filter(function (block) { return block.id !== action.ref; });
                }
                state.block.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_DELETE.SUCCESS:
                state.block.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_DELETE.ERROR:
                state.block.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case BLOCK_DELETE.RESET:
                state.block.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                    ref: '',
                };
                break;
            case BLOCK_DUPLICATE.REQUEST:
                state.block.duplicate = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case BLOCK_DUPLICATE.SUCCESS:
                state.block.duplicate = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case BLOCK_DUPLICATE.ERROR:
                state.block.duplicate = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case BLOCK_DUPLICATE.RESET:
                state.block.duplicate = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                };
                break;
            case CONNECTOR_CREATE.REQUEST:
                state.connector.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case CONNECTOR_CREATE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.data) &&
                    ((_16 = state.customLogic.read) === null || _16 === void 0 ? void 0 : _16.data) &&
                    ((_17 = state.customLogic.read.data) === null || _17 === void 0 ? void 0 : _17.id) === action.data.patchwork) {
                    state.customLogic.read.data.edges = __spreadArray(__spreadArray([], state.customLogic.read.data.edges, true), [
                        action.data,
                    ], false);
                }
                state.connector.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                };
                break;
            case CONNECTOR_CREATE.ERROR:
                state.connector.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case CONNECTOR_CREATE.RESET:
                state.connector.create = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                };
                break;
            case CONNECTOR_UPDATE.REQUEST:
                state.connector.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                };
                break;
            case CONNECTOR_UPDATE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.data) &&
                    ((_18 = state.customLogic.read) === null || _18 === void 0 ? void 0 : _18.data) &&
                    ((_19 = state.customLogic.read.data) === null || _19 === void 0 ? void 0 : _19.id) === action.data.patchwork) {
                    state.customLogic.read.data.edges = __spreadArray(__spreadArray([], (_20 = state.customLogic.read.data.edges) === null || _20 === void 0 ? void 0 : _20.filter(function (edge) { var _a; return edge.id !== ((_a = action.data) === null || _a === void 0 ? void 0 : _a.id); }), true), [
                        action.data,
                    ], false);
                }
                state.connector.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                    ref: (_21 = action.data) === null || _21 === void 0 ? void 0 : _21.id,
                };
                break;
            case CONNECTOR_UPDATE.ERROR:
                state.connector.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                };
                break;
            case CONNECTOR_UPDATE.RESET:
                state.connector.update = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                };
                break;
            case CONNECTOR_DELETE.REQUEST:
                state.connector.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.LOADING,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case CONNECTOR_DELETE.SUCCESS:
                if ((action === null || action === void 0 ? void 0 : action.ref) && !!((_23 = (_22 = state.customLogic.read) === null || _22 === void 0 ? void 0 : _22.data) === null || _23 === void 0 ? void 0 : _23.edges)) {
                    state.customLogic.read.data.edges =
                        (_24 = state.customLogic.read.data.edges) === null || _24 === void 0 ? void 0 : _24.filter(function (connector) { return connector.id !== action.ref; });
                }
                state.connector.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.SUCCESS,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case CONNECTOR_DELETE.ERROR:
                state.connector.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.ERROR,
                    ref: action === null || action === void 0 ? void 0 : action.ref,
                };
                break;
            case CONNECTOR_DELETE.RESET:
                state.connector.delete = {
                    data: undefined,
                    status: RESPONSE_STATUS.IDLE,
                    ref: '',
                };
                break;
            case APP_OPTION_LIST.REQUEST:
                state.appOptionList.status = RESPONSE_STATUS.LOADING;
                state.appOptionList.data = [];
                break;
            case APP_OPTION_LIST.SUCCESS:
                state.appOptionList.status = RESPONSE_STATUS.SUCCESS;
                state.appOptionList.data = (_25 = action === null || action === void 0 ? void 0 : action.options) !== null && _25 !== void 0 ? _25 : [];
                break;
            case APP_OPTION_LIST.ERROR:
                state.appOptionList.status = RESPONSE_STATUS.ERROR;
                state.appOptionList.data = [];
                break;
            case DUPLICATE_CUSTOM_LOGIC.REQUEST:
                state.customLogicDuplicateState = RESPONSE_STATUS.LOADING;
                break;
            case DUPLICATE_CUSTOM_LOGIC.SUCCESS:
                state.customLogicDuplicateState = RESPONSE_STATUS.SUCCESS;
                break;
            case DUPLICATE_CUSTOM_LOGIC.ERROR:
                state.customLogicDuplicateState = RESPONSE_STATUS.ERROR;
                break;
            case DUPLICATE_CUSTOM_LOGIC.RESET:
                state.customLogicDuplicateState = RESPONSE_STATUS.IDLE;
                break;
        }
    });
};
export default LogicBuilderReducer;
